var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbbLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 101,
    viewBox: "0 0 254 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.234 98.1133H143.994C161.273 97.2476 173.368 83.6848 173.368 67.5248C173.368 62.0419 172.216 56.559 169.624 52.2305H138.234V98.1133Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.353 51.9434H106.555V98.1148H135.353V51.9434Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.897 49.0562C165.017 45.0162 160.985 41.8419 156.665 39.5333C161.849 35.7819 165.305 29.7219 165.305 23.0848C165.305 11.8305 156.377 2.88477 145.146 2.88477H138.234V49.0562H167.897Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.353 2.88477H106.555V49.0562H135.353V2.88477Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M215.984 98.1133H221.744C239.023 97.2476 251.118 83.6848 251.118 67.5248C251.118 62.0419 249.966 56.559 247.374 52.2305H215.984V98.1133Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.103 51.9434H184.305V98.1148H213.103V51.9434Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M245.647 49.0562C242.767 45.0162 238.735 41.8419 234.415 39.5333C239.599 35.7819 243.055 29.7219 243.055 23.0848C243.055 11.8305 234.127 2.88477 222.896 2.88477H215.984V49.0562H245.647Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M213.103 2.88477H184.305V49.0562H213.103V2.88477Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2978 51.9434L2.88281 98.1148H26.7853L33.6969 77.9148H48.9599V51.9434H19.2978Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9544 2.88477H36.5712L20.1562 49.0562H48.9544V2.88477Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8359 77.9148H67.099L74.0105 98.1148H97.913L81.4981 51.9434H51.8359V77.9148Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6341 49.0562L64.2192 2.88477H51.8359V49.0562H80.6341Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbbLogo);
export default __webpack_public_path__ + "static/media/AbbLogo.0854841c58e2a11328f735c4c2feaaa5.svg";
export { ForwardRef as ReactComponent };